import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="relative bg-white dark:bg-gray-900 overflow-hidden">
        {/* Hero */}
        <div
          className="relative w-full h-[420px] md:h-[520px] bg-center bg-cover flex items-center justify-center"
          style={{ backgroundImage: `url(${t('home.heroImage')})` }}
        >
          <div className="absolute inset-0 bg-black/25" />
          <div className="relative z-10 text-center px-4 -translate-y-24 md:-translate-y-32">
            <h1 className="text-2xl md:text-4xl font-semibold mb-4 text-white drop-shadow">
              {t('home.heroTitle')}
            </h1>
            <p className="text-base md:text-lg text-white mb-6">
              {t('home.heroSub')}
            </p>

            <div className="relative inline-block">
              <Link
                to="/products"
                className="relative inline-flex items-center px-6 py-2 rounded-full text-white bg-[#34ab53] hover:bg-[#2c8f46] transition-colors"
              >
                {t('home.ctaProducts')}
              </Link>
            </div>
          </div>
        </div>

        {/* Story */}
        <div className="container mx-auto px-4 py-12">
          <p className="max-w-3xl mx-auto text-center text-gray-700 dark:text-gray-200 text-lg leading-relaxed">
            {t('home.story')}
          </p>
        </div>

        {/* OFFER SECTION — FIXED ALIGNMENT */}
        <div className="container mx-auto px-4 pb-10">
          <div className="max-w-5xl mx-auto bg-gray-50 dark:bg-gray-800 py-6 md:py-8 px-4 md:px-0 rounded-lg">
            <div className="md:px-6">
              <h2 className="text-2xl md:text-3xl font-extrabold text-center md:text-left text-[#1f4e50] mb-4">
                {t('home.offerTitle')}
              </h2>

              {/* FIXED GRID + ALIGNMENT */}
              <ul className="grid md:grid-cols-2 gap-6 text-gray-700 dark:text-gray-200 items-start">
                {t('home.offerItems', { returnObjects: true }).map((item, i) => (
                  <li key={i} className="flex items-start gap-3 leading-relaxed">
                    <span className="text-[#34ab53] mt-1 flex-shrink-0">✔️</span>
                    <span className="block">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Technology section */}
<div className="container mx-auto px-4 pb-16">
  <div className="max-w-5xl mx-auto px-4 md:px-6 md:pl-16">

    <h2 className="text-2xl md:text-3xl font-extrabold text-left text-[#1f4e50] mb-2">
      {t('home.techTitle')}
    </h2>

    <p className="text-left text-gray-700 dark:text-gray-300 mb-8">
      {t('home.techSubtitle')}
    </p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      <div className="space-y-4 text-gray-700 dark:text-gray-200">
        {t('home.techParagraphs', { returnObjects: true }).map((p, i) => (
          <p key={i} className="leading-relaxed">{p}</p>
        ))}
      </div>

      <div className="flex justify-center md:justify-end">
        <img src={t('home.techImage')} alt="Tech" className="w-full max-w-sm object-contain" />
      </div>
    </div>

  </div>
</div>


        {/* Sustainability */}
        <div className="container mx-auto px-4 pb-10">
          <div className="max-w-5xl mx-auto bg-gray-50 dark:bg-gray-800 p-6 md:p-8 rounded-lg">
            <h2 className="text-2xl md:text-3xl font-extrabold text-center text-[#1f4e50] mb-4">
              {t('home.sustainabilityTitle')}
            </h2>
            <ul className="space-y-3 text-gray-700 dark:text-gray-200 max-w-3xl mx-auto">
              {t('home.sustainabilityBullets', { returnObjects: true }).map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-[#34ab53] mr-2">–</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default HeroSection;
